import {
  getIdFullNameWithEmail,
  getIdFullNameWithEmailDeleted,
  getIdNameDeleted,
  optionToNamed,
  getIdFullNameError,
  getIdDisplayDeleted,
} from 'services/helpers';
import {
  TYPE_ROUND_ROBIN_ALL,
  TYPE_ROUND_ROBIN_ROLE,
  TYPE_ROUND_ROBIN_TEAM_MEMBERS,
  TYPE_TEAM_MEMBER,
  TYPE_TEAM_SELECTOR_FIELD,
  TYPE_RELATED_TEAM_SELECTOR_FIELD,
} from './common';

import {
  checkDeleted,
  displayNameDescriptor,
  checkListDeleted,
  nameDescriptor,
} from 'pages/AutomationEngine/helpers';

const forApi = (step) => {
  const orgDetails = { ...step.details };
  const type =
    orgDetails?.assignTeamMember?.assignmentType?.id || TYPE_ROUND_ROBIN_ALL;

  let api = {};
  switch (type) {
    case TYPE_TEAM_MEMBER:
      api = {
        type,
        employeeId: orgDetails.assignTeamMember.teamMember.id,
      };
      break;

    case TYPE_ROUND_ROBIN_ROLE:
      api = {
        type,
        roleId: orgDetails.assignTeamMember.role.id,
      };
      break;

    case TYPE_ROUND_ROBIN_TEAM_MEMBERS:
      api = {
        type,
        employeeIds: orgDetails.assignTeamMember.teamMembers.map(
          ({ id }) => id
        ),
      };
      break;

    case TYPE_TEAM_SELECTOR_FIELD:
      api = {
        type,
        fieldId: orgDetails.assignTeamMember.field.id,
      };
      break;

    case TYPE_RELATED_TEAM_SELECTOR_FIELD:
      api = {
        type,
        relatedFieldId: orgDetails.assignTeamMember.relatedField.id,
        fieldId: orgDetails.assignTeamMember.field.id,
      };
      break;

    default:
      // TYPE_ROUND_ROBIN_ALL:
      api = { type };
      break;
  }
  return { details: api };
};

const forFlow = (apiObject, addErrorMessage, messageDictionary, stepType) => {
  const { type, employee, employees, role, field, relatedField } = apiObject;

  if (type === TYPE_ROUND_ROBIN_ROLE) {
    checkDeleted(
      messageDictionary,
      addErrorMessage,
      role,
      nameDescriptor,
      messageDictionary.associatedRole
    );
  }

  if (type === TYPE_RELATED_TEAM_SELECTOR_FIELD) {
    checkDeleted(
      messageDictionary,
      addErrorMessage,
      relatedField,
      displayNameDescriptor,
      messageDictionary.relatedObjectField
    );
  }

  if (
    [TYPE_RELATED_TEAM_SELECTOR_FIELD, TYPE_TEAM_SELECTOR_FIELD].includes(type)
  ) {
    checkDeleted(
      messageDictionary,
      addErrorMessage,
      field,
      nameDescriptor,
      messageDictionary.field
    );
  }

  const flow = {
    // type is clashing with step type so let's force it here now we have set assignmentType
    type: stepType,
    assignTeamMember: {
      assignmentType: optionToNamed(
        messageDictionary.dictionaryAassignmentTypeOptions[type]
      ),
    },
  };

  if (employee) {
    checkDeleted(
      messageDictionary,
      addErrorMessage,
      employee,
      displayNameDescriptor
    );

    flow.assignTeamMember.teamMember = getIdFullNameWithEmailDeleted(employee);
  }

  if (role) {
    // deleting the role cause a back end issue
    flow.assignTeamMember.role = getIdNameDeleted(role);
  }

  if (employees?.length || type === TYPE_ROUND_ROBIN_TEAM_MEMBERS) {
    // employees are getting deleted from the list \o/
    checkListDeleted(
      messageDictionary,
      addErrorMessage,
      employees,
      displayNameDescriptor,
      type === TYPE_ROUND_ROBIN_TEAM_MEMBERS
        ? messageDictionary.teamMember
        : null,
      'employees',
      getIdFullNameError
    );
    flow.assignTeamMember.teamMembers = employees
      .filter(({ deleted }) => !deleted)
      .map(getIdFullNameWithEmail);
  }

  if (field) {
    flow.assignTeamMember.field = getIdDisplayDeleted(
      field,
      messageDictionary.deleted
    );
  }

  if (relatedField) {
    flow.assignTeamMember.relatedField = getIdDisplayDeleted(
      relatedField,
      messageDictionary.deleted
    );
  }

  return flow;
};
export const assignTeamMemberDTO = {
  forApi,
  forFlow,
};
